import RequestsRepository from '@/shared/http/repositories/realestate/requestRepository'
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  mixins: [ActionsForm, ExpenseMixin],
  name: 'searchRequests',
  components: {
    AutocompleteZ
  },
  data () {
    return {
      title: 'Buscar por Solicitações',
      dataspersonalizadas: false,
      enterprise: null,
      tablereload: 0,
      realestate: null,
      tower: null,
      apartment: null,
      SearchItems: {
        empreendimentoId: null,
        towerId: null,
        apartmentId: null,
        realestateId: null,
        brokerId: null,
        DataInicio: null,
        DataFinal: null,
        Status: null,
        clienteId: null,
        cliente: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        contaId: null,
        conta: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      StatusSolicitacao: [
        {value: null, text: 'Todos os status'},
        {value: 0, text: 'Aprovado'},
        {value: 1, text: 'Reprovado'},
        {value: 2, text: 'Pendente'},
        {value: 3, text: 'Pend de Ajuste'},
        {value: 4, text: 'Aprovado Pend.'}
      ],
      consultacomissao: null
    }
  },
  methods: {
    onLoad () {
      RequestsRepository.GetAllEnterprises()
        .then(Response => {
          this.enterprise = Response.data.data
        })
        .catch(() => {})

      RequestsRepository.GetAllTowers()
        .then(Response => {
          this.tower = Response.data
        })
        .catch(() => {})

      RequestsRepository.GetAllApartments()
        .then(Response => {
          this.apartment = Response.data
        })
        .catch(() => {})

      RequestsRepository.GetAllRealEstates()
        .then(Response => {
          this.realestate = Response.data.data
        })
        .catch(() => {})

      RequestsRepository.GetAllWeb()
        .then(Response => {
          this.Status = Response.data.data
        })
        .catch(() => {})

      RequestsRepository.GetClienteByNameProposta()
        .then(Response => {
          this.cliente = Response.data.data
        })
        .catch(() => {})

      RequestsRepository.GetCorretorByNameProposta()
        .then(Response => {
          this.conta = Response.data.data
        })
        .catch(() => {})
    },
    Clear () {
      this.$refs.ClientePropostaTypeahead.clear()
      this.$refs.CorretorPropostaTypeahead.clear()
      Object.keys(this.SearchItems).forEach(prop => {
        if (prop === 'cliente' || prop === 'conta') {
          this.SearchItems[prop].value = null
        } else {
          this.SearchItems[prop] = null
        }
      })
      this.$emit('SearchItems', this.SearchItems, false)
      localStoreHelper.solicitacoes.solicitacoes(null)
    },
    Search () {
      this.SearchItems.clienteId = this.SearchItems.cliente.value
      this.SearchItems.contaId = this.SearchItems.conta.value
      var today = new Date()
      if (this.SearchItems.DataInicio !== null && this.SearchItems.DataFinal === null) {
        this.SearchItems.DataFinal = today
      }
      this.$emit('SearchItems', this.SearchItems, true)
      localStoreHelper.solicitacoes.solicitacoes(this.SearchItems)
    },
    opcoes () {
      this.dataspersonalizadas = !this.dataspersonalizadas
    },
    semanal () {
      const now = new Date()

      var diferencaPSegunda = now.getDay() - 1
      var diferencaPSexta = (5 - now.getDay())

      const monday = new Date()
      monday.setDate(now.getDate() - diferencaPSegunda)

      const friday = new Date()
      friday.setDate(now.getDate() + diferencaPSexta)

      this.SearchItems.DataInicio = monday
      this.SearchItems.DataFinal = friday
      this.dataspersonalizadas = false
    },
    mensal () {
      const now = new Date()

      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)

      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0)

      this.SearchItems.DataFinal = lastDay
      this.SearchItems.DataInicio = firstDay
      this.dataspersonalizadas = false
    },
    anual () {
      const now = new Date()

      const firstDay = new Date(now.getFullYear(), 0, 1)

      const lastDay = new Date(now.getFullYear(), 11, 31)

      this.SearchItems.DataFinal = lastDay
      this.SearchItems.DataInicio = firstDay
      this.dataspersonalizadas = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/requests/components/searchRequests/searchRequests.js